export default {
  name: "Tool"
};